import React from 'react';

/** Shared by the Login Activity shell and its Sessions / Sign-ins views. */
export const loginActivityStyles: Record<string, React.CSSProperties> = {
  section: {
    background: 'var(--bg-surface-1)',
    border: '1px solid var(--border-1)',
    borderRadius: 'var(--radius-lg)',
    padding: '20px',
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '16px',
    flexWrap: 'wrap' as const,
    gap: '12px',
  },
  sectionTitle: {
    margin: 0,
    fontSize: '16px',
    fontWeight: 600,
    color: 'var(--fg-1)',
  },
  sectionSubtitle: {
    margin: '4px 0 0 0',
    fontSize: '12px',
    color: 'var(--fg-3)',
    maxWidth: 640,
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap' as const,
    gap: '12px',
    marginBottom: '12px',
  },
  searchInput: {
    padding: '8px 12px',
    border: '1px solid var(--border-2)',
    borderRadius: 'var(--radius-md)',
    fontSize: '13px',
    background: 'var(--bg-surface-1)',
    color: 'var(--fg-1)',
    width: '240px',
    maxWidth: '100%',
    fontFamily: 'var(--font-sans)',
  },
  loadMoreRow: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '8px',
  },
  loadingRow: {
    display: 'flex',
    justifyContent: 'center',
    padding: '24px 0',
  },
  errorBanner: {
    fontSize: '13px',
    fontWeight: 500,
    color: 'var(--danger)',
    background: 'var(--danger-soft)',
    border: '1px solid var(--cg-terra-200)',
    borderRadius: 'var(--radius-md)',
    padding: '10px 12px',
    marginBottom: '12px',
  },
};
